import { render } from "./ThemeSwitcher.vue?vue&type=template&id=799b3d4c&scoped=true"
import script from "./ThemeSwitcher.vue?vue&type=script&lang=js"
export * from "./ThemeSwitcher.vue?vue&type=script&lang=js"

import "./ThemeSwitcher.vue?vue&type=style&index=0&id=799b3d4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799b3d4c"]])

export default __exports__